import axios from 'axios'
import {
  // getToken,
  removeToken
} from '@/utils/auth'
import settings from '@/utils/settings'
// create an axios instance

const appId = settings.appId
const gameId = settings.gameId
const lang = settings.lang
const game = settings.game
// if (process.env.NODE_ENV === 'development') {
axios.defaults.baseURL = '//gateway-dev.r2game.com'
axios.defaults.timeout = 50000
axios.defaults.headers = {
  'Content-Type': 'application/x-www-form-urlencoded'
}

// response interceptor
axios.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    if (res.code === 2) {
      removeToken()
      // to re-login
      // MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again',
      //   'Confirm logout', {
      //     confirmButtonText: 'Re-Login',
      //     cancelButtonText: 'Cancel',
      //     type: 'warning'
      //   }).then(() => {
      //     removeToken()
      //     window.location.href = '//gateway.r2games.com.cn/?ct=acc&appId=' + appId + '&accAppId=' + accAppId
      // })
    }

    // if the custom code is not 0, it is judged as an error.
    if (res.code !== 0) {
      console.log({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      return res
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    console.log({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

/**
 * Get请求
 */
export function get(url, callback) {
  // const ctoken = getToken()

  if (url.indexOf('?') === -1) {
    url += '?appId=' + appId +'&gameId=' + gameId + '&lang=' + lang + '&game=' + game
  } else {
    url += '&appId=' + appId +'&gameId=' + gameId + '&lang=' + lang + '&game=' + game
  }

  axios.get(url)
    .then(function(response) {
      console.log(response)
      callback(response.data, true)
    })
    .catch(function(error) {
      console.log(error)
      callback(null, false)
    })
}

export function post(url, data) {
  // const ctoken = getToken()

  if (url.indexOf('?') === -1) {
    url += '?appId=' + appId +'&gameId=' + gameId + '&lang=' + lang  + '&game=' + game
  } else {
    url += '&appId=' + appId +'&gameId=' + gameId + '&lang=' + lang  + '&game=' + game
  }
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(response => {
      resolve(response)
    }).catch(e => {
      reject(e)
    })
  })
}
